module.exports = __webpack_public_path__ + "img/Pet Care.b8fd4adc.svg";